import { useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import NewProdLabel from './NewProdLabel';
import CommercialLabel from './CommercialLabel';
import SoldLabel from './SoldLabel';
import { ServicesTitles, StatusId, Estates, EstateType } from '~js/React/Enums';

const ObjectHeroInformation = () => {
  const { estate: data } = useContext(ObjectPageContext);
  const longAdressInfo =
    data?.addressInfo?.city?.length + data?.addressInfo?.area?.length > 40
      ? true
      : false;

  return (
    <div className="flex flex-col text-white font-ic lg:max-w-4/5 w-full min-w-[320px]">
      <div className="relative w-auto self-start mb-2 lg:mb-3 pr-8">
        <span
          className={`text-base lg:text-lg xl:text-xl ${
            longAdressInfo ? '' : 'whitespace-nowrap'
          }`}
        >
          {data?.addressInfo?.city}
          {data?.addressInfo?.city &&
          data?.addressInfo?.area &&
          data?.addressInfo?.area &&
          data?.addressInfo?.area.toLowerCase() !=
            data?.addressInfo?.city.toLowerCase()
            ? ' - '
            : ''}
          {data?.addressInfo?.area &&
          data?.addressInfo?.area.toLowerCase() !=
            data?.addressInfo?.city.toLowerCase()
            ? data?.addressInfo?.area
            : ''}
        </span>
        {data?.estateTypeAsString === EstateType.Project && <NewProdLabel />}
        {data?.estateTypeAsString === EstateType.Commercial &&
          data?.isForSaleOrHeadStart && <CommercialLabel />}
        {data?.status?.id == StatusId.Sold && <SoldLabel />}
      </div>
      <h1
        className={`font-lf text-3xl lg:text-5xl leading-7 md:leading-9 lg:leading-12 mb-3 lg:mb-4 w-fit lg:max-w-4/5`}
      >
        {data?.estateTypeAsString === EstateType.Project && (
          <>{data?.projectName}</>
        )}
        {data?.estateTypeAsString !== EstateType.Project &&
          data?.addressInfo?.streetAddress &&
          data?.addressInfo?.streetAddress !== '-' && (
            <>{data?.addressInfo?.streetAddress}</>
          )}
      </h1>
      <div className="flex flex-wrap">
        {data?.isHeadStart && (
          <div className="flex flex-row gap-2 hero-service">
            <button
              onClick={() => {
                document
                  .getElementById('serviceItems')
                  .scrollIntoView({ block: 'center', behavior: 'smooth' });
              }}
              className="header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic"
            >
              Kommande försäljning
            </button>
          </div>
        )}
        {data?.inspected && (
          <div className="flex flex-row gap-2 hero-service">
            <button
              onClick={() => {
                document
                  .getElementById('serviceItems')
                  .scrollIntoView({ block: 'center', behavior: 'smooth' });
              }}
              className="header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic"
            >
              {Estates.LDPlus}
            </button>
          </div>
        )}
        {data?.isGreenEstate && (
          <div className="flex flex-row gap-2 hero-service">
            <button
              onClick={() => {
                document
                  .getElementById('serviceItems')
                  .scrollIntoView({ block: 'center', behavior: 'smooth' });
              }}
              className="header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic"
            >
              {ServicesTitles.GreenEstate}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ObjectHeroInformation;
